import React, { useState } from 'react';
import './index.scss';
import { getFeedsTitleText, getNewsContentText } from '@op/utils/languageValue';
import { LanguageType, SentimentType } from '@op/types/common';
import SentimentEditBox from '@/pages/opinion/components/SentimentEditBox';
import RegionCountryItem from '@op/components/Snippets/RegionCountryItem';
import { transChannel, transRegion } from '@op/utils';
import { getLocale } from 'umi';
import ChannelLabel from '@op/components/ChannelLabel';
import appfamitsuIcon from '@op/assets/svg/appfamitsu-icon.svg';
import NewsModal from '@op/pages/news/widgets/NewsModal';
import {
  getLogValue,
  logCommentMapType,
} from '@op/pages/feeds/hooks/useFeedsRequest';
import CommonBubble from '@home/components/CommonBubble';
export default function ArticleReviews({
  data,
  language,
  logCommentMap,
  logLoading,
  getContentInfo,
}: {
  data: any;
  language: LanguageType;
  logCommentMap: logCommentMapType;
  logLoading: boolean;
  getContentInfo: (text: string) => string | any;
}) {
  const textChannel = transChannel(data.source);
  const [visible, setVisible] = useState(false);

  return (
    <>
      <NewsModal
        visible={visible}
        data={data}
        languageType={language}
        close={() => {
          setVisible(!visible);
        }}
      />
      <div className="dbo-article-reviews">
        <CommonBubble
          overlayClassName="dbo-scroll-bubble"
          content={
            <div className="dbo-scroll-bubble-scroll">
              {getFeedsTitleText(data, language)} 
            </div>
          }
        >
          <div
            className="dbo-article-reviews-title"
            onClick={() => setVisible(true)}
          >
            {getFeedsTitleText(data, language)}
          </div>
        </CommonBubble>
        <CommonBubble
          overlayClassName="dbo-scroll-bubble"
          content={
            <div className="dbo-scroll-bubble-scroll">
              {getNewsContentText(data, language)} 
            </div>
          }
        >
          <div
            className="dbo-article-reviews-content"
            onClick={() => setVisible(true)}
          >
            {getContentInfo(getNewsContentText(data, language))}
          </div>
        </CommonBubble>
        <div className="dbo-article-reviews-operate">
          <div className="dbo-article-reviews-operate-item">
            {/* 选择表情组件 */}
            <SentimentEditBox
              data={data}
              realValue={
                getLogValue(
                  logCommentMap,
                  data,
                  'latest_sentiment',
                ) as SentimentType
              }
              sentimentLoading={logLoading}
              needRequest={false}
              type="news"
            ></SentimentEditBox>
          </div>
          <div className="dbo-article-reviews-operate-item">
            {/* channellabel 组件 */}
            <div className="dbo-channellabel dbo-channellabel--market undefined">
              <ChannelLabel
                showText={false}
                channel_name={textChannel}
                defaultImage={appfamitsuIcon}
              ></ChannelLabel>
            </div>
            <span className="dbo-article-reviews-operate-text">
              {textChannel}
            </span>
          </div>
          <div className="dbo-article-reviews-operate-item">
            {/* channellabel 组件 */}
            <div className="dbo-channellabel dbo-channellabel--market undefined">
              <RegionCountryItem
                showText={false}
                market={data.market}
              ></RegionCountryItem>
            </div>
            <span className="dbo-article-reviews-operate-text">
              {transRegion(data.news_language, getLocale() === 'en-US' ? 3 : 6)}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
